import { RESOURCES_ACTIONS } from '../constants/action.constants';

export function resourceAdd(resource, payload) {
  return {
    type: RESOURCES_ACTIONS.ADD,
    resourceKey: resource?.key,
    payload
  };
}

export function resourceUpdate(resource, field, value) {
  return {
    type: RESOURCES_ACTIONS.UPDATE,
    resourceKey: resource?.key,
    field,
    value
  };
}

export function resourceReset(resource) {
  return {
    type: RESOURCES_ACTIONS.RESET,
    resourceKey: resource?.key
  };
}
